import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import * as serviceWorker from './serviceWorker';
import { createStore } from 'redux' ;
import { Provider } from 'react-redux';
// import { initStore } from './store/store'
import rootReducer from './reducers'
import { createBrowserHistory } from 'history'
import { Router } from "react-router";
import App from './App';

const store = createStore(rootReducer);
const history = createBrowserHistory()

ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <App />
        </Router>
    </Provider>, document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
